export const namespace: string = "manager";

export const webTitle: string = "";

export const VERSION_VALUE = 56;

/**表格距离底部的数值（调整表格高度）*/
export const TABLE_MARGIN_BOTTOM: number = 38;
export const TABLE_MARGIN_BOTTOM_BUTTON: number = 40;
export const TAB_TABLE_MARGIN_BOTTOM: number = 120;
export const PRINT_TAB_MARGIN_BOTTOM: number = 200;
export const PRINT_DETAIL_MARGIN_BOTTOM: number = 240;
/**默认表格高度*/
export const TABLE_DEFAULT_HEIGHT: number = 500;
export const PRINT_DEFAULT_HEIGHT: string = "600px";
export const COUNT_TABLE_HEIGHT:number=70;
/**抽屉宽度*/
export const DRAWER_DEFAULT_SIZE: string = "75%";
/**时间数值*/
export const DRAWER_OPEN_TIME_VALUE: number = 600;
export const MESSAGE_SHOW_TIME_VALUE: number = 1000;
export const AUTO_SIZE_TIME_VALUE: number = 800;
export const SET_FOCUS_TIME_VALUE: number = 800;
export const SUBMIT_FIAL_TIME_VALUE: number = 2000;
export const DROP_CLOSE_TIME_VALUE: number = 500;
/**提交显示的背景颜色*/
export const LOADING_BACKGROUND:string='rgba(0, 0, 0, 0.7)';

/**col响应值(列表页面按钮和查询条件)*/
export const COL_XS_LIST: number = 24;/**xs (extra small): 手机 (<768px)*/
export const COL_SM_LIST: number = 24;/**sm (small): 平板 (≥768px)*/
export const COL_MD_LIST: number = 8;/**md (medium): 桌面 (≥992px)*/
export const COL_LG_LIST: number = 6;/**lg (large): 大桌面 (≥1200px)*/
export const COL_XL_LIST: number = 4;/**xl (extra large): 超大桌面 (≥1920px)*/

export const COL_XS_LIST_3: number = 24;/**xs (extra small): 手机 (<768px)*/
export const COL_SM_LIST_3: number = 24;/**sm (small): 平板 (≥768px)*/
export const COL_MD_LIST_3: number = 6;/**md (medium): 桌面 (≥992px)*/
export const COL_LG_LIST_3: number = 5;/**lg (large): 大桌面 (≥1200px)*/
export const COL_XL_LIST_3: number = 2;/**xl (extra large): 超大桌面 (≥1920px)*/

/**操作界面的form */
export const COL_XS_OPERATE_3: number = 24;
export const COL_SM_OPERATE_3: number = 8;
export const COL_MD_OPERATE_3: number = 8;
export const COL_LG_OPERATE_3: number = 8;
export const COL_XL_OPERATE_3: number = 8;

export const COL_XS_OPERATE_4: number = 24;
export const COL_SM_OPERATE_4: number = 6;
export const COL_MD_OPERATE_4: number = 6;
export const COL_LG_OPERATE_4: number = 6;
export const COL_XL_OPERATE_4: number = 6;

export const COL_XS_OPERATE_6: number = 24;
export const COL_SM_OPERATE_6: number = 8;
export const COL_MD_OPERATE_6: number = 4;
export const COL_LG_OPERATE_6: number = 4;
export const COL_XL_OPERATE_6: number = 4;

export const COL_XS_OPERATE_24: number = 12;
export const COL_SM_OPERATE_24: number = 4;
export const COL_MD_OPERATE_24: number = 4;
export const COL_LG_OPERATE_24: number = 4;
export const COL_XL_OPERATE_24: number = 4;

export const circleUrl: string ="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png";
